import { Mapper } from "../../../../base/utils/mapper";
import { DiagnosticResponseModel } from "../../../../domain/models/consult/diagnostic-response.model";
import { DiagnosticResponseEntity } from "../entities/diagnostic-response.entity";

export class DiagnosticImplementationRepositoryMapper extends Mapper<DiagnosticResponseEntity, DiagnosticResponseModel> {
    mapFrom(param: DiagnosticResponseEntity): DiagnosticResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: DiagnosticResponseModel): DiagnosticResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}